<template>
  <!-- BEGIN CONTENT BODY -->
  <!-- BEGIN PAGE HEADER-->
  <div>
    <breadcrumb-bar :crumbs="['Manage Users']"></breadcrumb-bar>
    <!-- END PAGE HEADER-->
    <div class="col-md-12">
      <div class="row">
        <div class="portlet light">
          <div class="portlet-title tabbable-line">
            <div class="caption caption-md">
              <i class="icon-globe theme-font hide"></i>
              <span class="caption-subject bold uppercase">MANAGE USERS</span>
            </div>
            <ul class="nav nav-tabs">
              <li class="active">
                <a href="#update-access" data-toggle="tab" aria-expanded="false">Manage Users</a>
              </li>
            </ul>
          </div>
          <div class="tab-content marginTop">
            <div class="tab-pane active" id="update-access">
              <manage-users-form></manage-users-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
  import ManageUsersForm from '@/components/forms/ManageUsersForm'
  import Breadcrumbs from '@/components/Breadcrumbs'
  import {mapGetters, mapActions} from 'vuex'
  export default {
    components: {
      ManageUsersForm,
      'breadcrumb-bar': Breadcrumbs
    },
    computed: {
      ...mapGetters({
        user: 'getUser'
      })
    },
    methods: {
      ...mapActions({
        getAccount: 'GET_ACCOUNT_ACTION',
        resetAccount: 'RESET_ACCOUNT_ACTION',
      })
    },
    beforeMount() {
      this.resetAccount();
      this.getAccount(this.user.organizations[0].id);
    }
  }
</script>



// WEBPACK FOOTER //
// ManageUsers.vue?6bce0c9c